import SapFiReport from "./pages/SapFiReport.vue";
import SapMmReport from "./pages/SapMmReport.vue";
import SapMmErrorReport from "./pages/SapMmErrorReport.vue";
import SapFiErrorReport from "./pages/SapFiErrorReport.vue";
import SapLayout from "./SapLayout.vue";
import SapMmPoVenderReport from "./pages/SapMmPoVenderReport.vue"
import SapFiNotSendReceipt from "./pages/SapFiNotSendReceipt.vue";

export const sapPathRoutes = (prefix = "") => [
  {
    name: "SapFiReport",
    path: "sap-fi-report",
    component: SapFiReport
  },
  {
    name: "SapMmReport",
    path: "sap-mm-report",
    component: SapMmReport
  },
  {
    name: "SapFiErrorReport",
    path: "sap-fi-error-report",
    component: SapFiErrorReport
  },
  {
    name: "SapMmErrorReport",
    path: "sap-mm-error-report",
    component: SapMmErrorReport
  },
  {
    name: "SapMmPoVenderReport",
    path: "sap-mm-po-vender-report",
    component: SapMmPoVenderReport
  },
  {
    name: "SapFiNotSendReceipt",
    path: "sap-fi-not-send-receipt",
    component: SapFiNotSendReceipt
  },
];

export const sapRoutes = {
  path: "sap",
  component: SapLayout,
  children: [
    ...sapPathRoutes()
  ]
};



// WEBPACK FOOTER //
// ./src/features/sap/routes.js